import { makeAutoObservable, runInAction } from 'mobx'
import { RequestLoadData } from 'shared/api/lib'
import { InboxesApi } from 'entities/Inbox'
import { Inbox } from 'entities/Inbox/model/Inbox'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class InboxesTeamStore {
  private _inboxesMap: Map<number | string, Inbox> = new Map()
  private _selectedItemId: Null<number> = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
    this.init()
  }

  init = async () => {
    await this.fetchAllInboxes()
    runInAction(() => {
      this._selectedItemId = this._entities.organizationStore.fallbackTeamId
    })
  }

  private _status = new RequestLoadData({
    requestCallback: async ({ cancelRequest }) => {
      const { data } = await InboxesApi.getTeamsAll(undefined, {
        cancelToken: cancelRequest.token,
      })
      data.forEach((item) => {
        if (item.type !== 'inbox') return
        this._inboxesMap.set(item.id, new Inbox(item, this._entities))
      })
    },
  })

  fetchAllInboxes = () => this._status.blockingLoadData()

  updateFallbackTeamId = (id: number) => this._entities.organizationStore.updateFallbackTeamId(id)

  selectInbox = (itemId: number) => {
    this._selectedItemId = itemId
    this.updateFallbackTeamId(itemId)
  }

  get selectedInboxId() {
    return this._selectedItemId
  }

  get inboxes() {
    return Array.from(this._inboxesMap.values()).filter((inbox) => !inbox.isRCS)
  }

  get status() {
    return this._status.status
  }
}
